<template>
  <section>
    <h3 class="h-title">服务文本<div class="h-tag">（注：系统提供模板，请您下载盖章后上传）</div></h3> 
    <el-form class="e-form f-b" ref="cForm5" :model="cForm5" label-width="250px"  label-position="left" :rules="setpFormRules5">  
      <el-form-item class="w-70" label="债权治理申请书" prop="serviceApplyFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'serviceApplyFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'serviceApplyFile')" 
            :on-error="handleError"
            :file-list="cForm5.serviceApplyFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
        <div class="el-form-item__error" v-show="isFile.serviceApplyFile">
          请上传
        </div>
      </el-form-item> 
      <el-form-item class="w-70" label="推介服务协议" prop="serviceSuggestProtocolFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'serviceSuggestProtocolFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'serviceSuggestProtocolFile')" 
            :on-error="handleError"
            :file-list="cForm5.serviceSuggestProtocolFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
        <div class="el-form-item__error" v-show="isFile.serviceSuggestProtocolFile">
          请上传
        </div>
      </el-form-item> 
      <el-form-item class="w-70" label="债权治理协议" prop="serviceGovernProtocolFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'serviceGovernProtocolFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'serviceGovernProtocolFile')" 
            :on-error="handleError"
            :file-list="cForm5.serviceGovernProtocolFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
        <div class="el-form-item__error" v-show="isFile.serviceGovernProtocolFile">
          请上传
        </div>
      </el-form-item> 
      <el-form-item class="w-70" label="债权治理公告【信息公示服务】" prop="serviceNoticeFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'serviceNoticeFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'serviceNoticeFile')" 
            :on-error="handleError"
            :file-list="cForm5.serviceNoticeFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
        <div class="el-form-item__error" v-show="isFile.serviceNoticeFile">
          请上传
        </div>
      </el-form-item> 
      <el-form-item class="w-70" label="债权到期偿付提示函" prop="serviceTipsLetterFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'serviceTipsLetterFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'serviceTipsLetterFile')" 
            :on-error="handleError"
            :file-list="cForm5.serviceTipsLetterFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="债权到期偿付事宜回函" prop="serviceReasonLetterFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'serviceReasonLetterFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'serviceReasonLetterFile')" 
            :on-error="handleError"
            :file-list="cForm5.serviceReasonLetterFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="债权治理服务终止通知书" prop="serviceAdviceFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'serviceAdviceFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'serviceAdviceFile')" 
            :on-error="handleError"
            :file-list="cForm5.serviceAdviceFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="授权划付通知书【资金结算服务】" prop="serviceTransferAdviceFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'serviceTransferAdviceFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'serviceTransferAdviceFile')" 
            :on-error="handleError"
            :file-list="cForm5.serviceTransferAdviceFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
    </el-form>
    <!-- 按钮 -->					
    <div class="cenrer">		
      <el-button class="s-but" type="orange" @click.native="prev">上一步</el-button>
      <el-button class="s-but" type="orange" @click="cSubmitForm('0')" :loading="butLoading">保 存</el-button>
      <el-button class="s-but" type="orange" @click.native="cSubmitForm('1')" :loading="butLoading">下一步</el-button>
    </div>
  </section>
</template>
<script>
import baseUrl from '@/api/baseUrl.js'
export default {
    name: "step5",
    props: ["active"],
		data() {
			return {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("token")
        },      
        cForm5: {}, 
				setpFormRules5: {
          serviceApplyFile: [
							{ type: 'array', required: true, message: '请上传', trigger: 'change' }
          ],
          serviceSuggestProtocolFile: [
							{ type: 'array', required: true, message: '请上传', trigger: 'change' }
          ],
          serviceGovernProtocolFile: [
							{ type: 'array', required: true, message: '请上传', trigger: 'change' }
          ],
          serviceNoticeFile: [
							{ type: 'array', required: true, message: '请上传', trigger: 'change' }
          ]
        },
        action: '',
        butLoading: false,
        sceneTypeText: '',
        isFile:{
          serviceApplyFile: false,
          serviceSuggestProtocolFile: false,
          serviceGovernProtocolFile: false,
          serviceNoticeFile: false
        }
			}
    },
    watch: {
      active(newVal) {
        if(newVal == 5) {
          window.scrollTo(0,0);
          this.action = `${baseUrl.iaccUrl}/iacc-contract-platform/common/uploadFile`;
          // this.action = `http://172.30.15.232:9097/common/uploadFile`;
          this.cForm5 = JSON.parse(sessionStorage.setpForm);
          this.cForm5.serviceApplyFile = JSON.parse(this.cForm5.serviceApplyFile || '[]');
          this.cForm5.serviceSuggestProtocolFile = JSON.parse(this.cForm5.serviceSuggestProtocolFile || '[]');
          this.cForm5.serviceGovernProtocolFile = JSON.parse(this.cForm5.serviceGovernProtocolFile || '[]');
          this.cForm5.serviceNoticeFile = JSON.parse(this.cForm5.serviceNoticeFile || '[]');
          this.cForm5.serviceTipsLetterFile = JSON.parse(this.cForm5.serviceTipsLetterFile || '[]');
          this.cForm5.serviceReasonLetterFile = JSON.parse(this.cForm5.serviceReasonLetterFile || '[]');
          this.cForm5.serviceAdviceFile = JSON.parse(this.cForm5.serviceAdviceFile || '[]');
          this.cForm5.serviceTransferAdviceFile = JSON.parse(this.cForm5.serviceTransferAdviceFile || '[]');
        } 
      }
    },
    methods: {  
      fontData(){
        this.cForm5.serviceApplyFile = JSON.stringify(this.cForm5.serviceApplyFile||[]);
        this.cForm5.serviceSuggestProtocolFile = JSON.stringify(this.cForm5.serviceSuggestProtocolFile||[]);
        this.cForm5.serviceGovernProtocolFile = JSON.stringify(this.cForm5.serviceGovernProtocolFile||[]);
        this.cForm5.serviceNoticeFile = JSON.stringify(this.cForm5.serviceNoticeFile||[]);
        this.cForm5.serviceTipsLetterFile = JSON.stringify(this.cForm5.serviceTipsLetterFile||[]);
        this.cForm5.serviceReasonLetterFile = JSON.stringify(this.cForm5.serviceReasonLetterFile||[]);
        this.cForm5.serviceAdviceFile = JSON.stringify(this.cForm5.serviceAdviceFile||[]);
        this.cForm5.serviceTransferAdviceFile = JSON.stringify(this.cForm5.serviceTransferAdviceFile||[]);
      },
      cSubmitForm(type) {
        if(type == '0'){
          this.butLoading = true;
          this.cForm5.status = '0'
          this.fontData()
          this.$api.creditorsRights.addAndUpd(JSON.stringify(this.cForm5)).then(response => {
            this.butLoading = false;
            if(response.code == 200){
              sessionStorage.removeItem("setpForm")
              this.$message.success("保存成功");
              this.$router.go(-1);
            }     
          });
        }else{
          // 文件必填校验
          let isAll = 0
          for(let key in this.isFile){
            if(!this.cForm5[key] || this.cForm5[key].length == 0){
              this.isFile[key] = true;
              isAll++
            }else {
              this.isFile[key] = false;
            }
          }
          if(isAll <= 0){
            this.fontData()
            sessionStorage.setpForm = JSON.stringify(this.cForm5);
            this.$emit('next'); 
          }            
        }          
      },
      prev() {
        this.fontData()
        sessionStorage.setpForm = JSON.stringify(this.cForm5);
        this.$emit('prev')
      },
      handleError(err, file, fileList){
        this.$message.error(file.name + "文件上传失败");
      },
      beforeUpload(file) { 	
        const isLt2M = file.size / 1024 / 1024 <= 80     //这里做文件大小限制
        
        if(!isLt2M) {
          this.$message.error('上传文件大小不能超过 80MB！');
        }
        return isLt2M
      },
      upload(response, file, list, name){
          if(response.code == 200){
            this.$set(this.cForm5, name, [{
              name: response.name,
              url: response.url
            }])
            this.isFile[name] = false
          }else{
            this.$set(this.cForm5, name,[])
            this.isFile[name] = true
            if(response.msg){
              this.$message.error(response.msg);
            }else {
              this.$message.error(file.name + "文件上传失败");
            }							
          }             
      },
      handleRemove(file, fileList, name) {
        this.$set(this.cForm5, name, [])
      },
    }
	}
</script>